import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import MBOSLogo from '@/assets/images/mbos_logo.png';
import TabLabelIcon from '@/components/TabLabel/TabLabelIcon';
import TooltipComponent from '@/components/UI/Tooltip/TooltipComponent';
import styles from './ValueByMBOSLabel.module.scss';

interface ValueByMBOSLabelProps {
  isFromTable?: boolean;
  isTableLegend?: boolean;
}

const ValueByMBOSLabel = ({ isFromTable = false, isTableLegend = false }: ValueByMBOSLabelProps) => {
  const { t } = useTranslation();

  if (isTableLegend) {
    return (
      <div className={styles.TableKey}>
        <TabLabelIcon isProvidedField extraClass={styles.BigIcon} />
        {t('dialog.valueBy')}
        <div className={styles.MBOSLogoContainerTableKey}>
          <img src={MBOSLogo} alt="MBOS Logo" />
        </div>
      </div>
    );
  }

  return (
    <TooltipComponent
      classes={{ tooltip: styles.TooltipFreeText }}
      arrow
      title={(
        <div className={styles.MBOSTooltip}>
          <Typography variant="body2" component="span">{t(`dialog.valueByMBOS`)}</Typography>
        </div>
      )}
    >
      <span className={styles.InfoIconContainer}>
        <TabLabelIcon isProvidedField extraClass={`${isFromTable ? styles.SmallIcon : ''}`} />
        {!isFromTable && (
          <div className={styles.MBOSLogoContainer}>
            <img className={styles.MBOSLogoLabel} src={MBOSLogo} alt="MBOS Logo" />
          </div>
        )}
      </span>
    </TooltipComponent>
  );
};

export default ValueByMBOSLabel;
